import { Avatar } from '@mui/material';

export default function UserAvatar({
  displayName,
  avatarUrl,
  size = 40,
}: {
  displayName: string;
  avatarUrl: string | null;
  size?: number;
}) {
  const initials = displayName
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  return (
    <Avatar src={avatarUrl ?? undefined} sx={{ width: size, height: size, fontSize: size * 0.4 }}>
      {initials}
    </Avatar>
  );
}
